export const OneItem = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1_130_99" fill="white">
<rect x="4" y="4" width="24" height="24" rx="1"/>
</mask>
<rect x="4" y="4" width="24" height="24" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-1-inside-1_130_99)"/>
<path d="M17 19V11H15V12H13V14H15V19H13V21H19V19H17Z" fill="currentColor"/>
</svg>`;
